import React from 'react';
import AdminHeader from './header/adminHeader.component';
import Footer from 'component/landing/footer';

// import { Container } from './styles';

export default function AdminLayout({ children }) {
  return (
    <div
      className="height-screen flex-column justify-between flex-end"
      style={{ minHeight: '100%' }}
    >
      <div>
        <AdminHeader />
        {children}
      </div>
      <Footer />
    </div>
  );
}
